import { CategoricalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	startRange: 'startRange',
	endRange: 'endRange',
	percentage: 'percentage',
	flatValue: 'flatValue',
	maxValue: 'maxValue'
};

export const conversionsConfig = [
	CategoricalColumn({
		title: 'Withdrawal Amount Start Range(₹)(Incl.)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.startRange]?.toLocaleString('en-IN') || '0'
	}),
	CategoricalColumn({
		title: 'Withdrawal Amount End Range(₹)(Excl.)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.endRange]?.toLocaleString('en-IN') || null
	}),
	CategoricalColumn({
		title: 'Fee Percentage(%)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.percentage] || '0'
	}),
	CategoricalColumn({
		title: 'Fee Flat Value(₹)',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.flatValue] || '0'
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 0,
		pageSize: 100
	},
	sortDetails: {
		sortField: 'code',
		sortOrder: 'ASC'
	}
};
